import { IContentService } from './utils';
import { ROUTES } from '../constants/routes';

const {
  aemRoutes: { specificPageRoute, commonRoute, baseRoute },
} = ROUTES;
export const AEM_ROUTES = {
  fetchDataFromContentService: (
    data: IContentService,
    isPageSpecific: boolean,
    brandCode: string,
  ): string => {
    const { state, language, pageName } = data;
    const resolvedState = state || 'IL';

    const query = isPageSpecific
      ? `brandCode=${brandCode}&language=${language}&pageName=${pageName}`
      : `brandCode=${brandCode}&language=${language}&componentName=${pageName}`;

    if (brandCode === 'healthspring') {
      return isPageSpecific
        ? `${baseRoute}${specificPageRoute}?state=${resolvedState}&${query}`
        : `${baseRoute}${commonRoute}?state=${resolvedState}&${query}`;
    }

    if (isPageSpecific) {
      return `${baseRoute}${specificPageRoute}?state=${state}&${query}`;
    } else {
      return `${baseRoute}${commonRoute}?state=${state}&${query}`;
    }
  },
};

export enum PAGE_NAME {
  MEMBER_VALIDATION = 'memberValidation',
  PAYMENT_TERMS = 'termCondition',
  ALL_PAYMENT_DETAILS = 'allPayments',
  ALL_PAYMENT_DETAILS_ACTIVE = 'allPaymentsActiveMember',
  PAYMENT_COMPLETED = 'paymentCompleted',
  CANCELLED_PAYMENT_CONFIRMATION = 'cancelledPaymentConfirmation',
  CANCELLED_CONFIRMATION_INTERSTITIAL = 'cancelledConfirmationInterstitial',
  UPDATE_PAYMENT_COMPLETED = 'updatePaymentConfirmation',
  PAYMENT_DETAILS = 'paymentsPage',
  PREMIUM_PAYMENTS = 'premiumPaymentsPage',
  SELECT_PLAN = 'multipleProductsLandingPage',
  MAPD_PAYMENTS = 'mapdPublicLink',
  PAYMENT_DETAILS_ACTIVE_MEMBER = 'paymentsPageActiveMember',
  MAKE_PAYMENT = 'makeAPayment',
  MAKE_PAYMENT_ACTIVE_MEMBER = 'makeAPaymentMember',
  REVIEW_PAYMENT_DETAILS = 'reviewPaymentPage',
  BROWSER_INCOMPATIBLE_ERROR = 'browserIncompatibleError',
  UNABLE_TO_PROCESS_PAYMENT = 'unableToProcessPayment',
  TECHNICAL_DIFFICULTY = 'technicalDifficulty',
  REVIEW_PAYMENT_DETAILS_ACTIVE_MEMBER = 'reviewPaymentPageActiveMember',
  MY_WALLET = 'myWallet',
  ADD_NEW_PAYMENT_METHOD_WALLET_BANK = 'addBank',
  ADD_NEW_PAYMENT_METHOD_WALLET_CARD = 'addCard',
  UPDATE_WALLET_BANK = 'updateBank',
  UPDATE_WALLET_CARD = 'updateCard',
  //Change the uri
  BINDER_VIEW_SCHEDULED_PAYMENTS = 'binderScheduledPaymentDetailsPage',
  VIEW_SCHEDULED_PAYMENTS = 'scheduledPaymentDetailsPage',
  SCHEDULED_PAYMENT_CONFIRMATION = 'scheduledPaymentConfirmation',
  AUTO_PAYMENT_SETTINGS = 'autoPaymentSettings',
  AUTO_PAYMENT_SUCCESS = 'autoPaymentConfirmationPage',
  PAYMENT_HISTORY = 'paymentHistory',
  BILLING_HISTORY_LIST = 'billingHistoryList',
  BILLING_HISTORY_SPREADSHEET = 'billingHistorySpreadsheet',
  BINDER_MAKE_PAYMENT = 'binderMakePayment',
  BINDER_PAY_LATER_MAKE_PAYMENT = 'binderPayLater',
  REVIEW_BINDER_PAYMENT_DETAILS = 'reviewBinderPaymentPage',
  APPLICANT_BINDER_PAYMENT_DETAILS = 'binderApplicantPage',
  BINDER_PAY_NOW_CONFIRMATION_PAYMENT_DETAILS = 'binderPayNowConfirmationPage',
  BINDER_PAY_LATER_CONFIRMATION_PAYMENT_DETAILS = 'binderPayLaterConfirmationPage',
  BINDER_PAY_LATER_CANCEL_CONFIRMATION_PAYMENT_DETAILS = 'binderPayLaterCancelConfirmationPage',
  BINDER_PAY_LATER_UPDATE_CONFIRMATION_PAYMENT_DETAILS = 'binderPayLaterUpdateConfirmationPage',
  BINDER_PAY_LATER_SCHEDULE_CONFIRMATION_PAYMENT_DETAILS = 'binderPayLaterScheduleConfirmationPage',
  BINDER_ALL_PAYMENTS_PAGE = 'binderAllPaymentsPage',
  BINDER_PAYMENTS_PAGE = 'binderPaymentsPage',
  HPS_MANAGED_ERROR = 'hpsManagedError',
  VIEW_PAYMENT_TRACKER_DETAILS_SCREEN = 'viewPaymentTrackerDetailsPage',
  PICK_YOUR_PLAN_VIEW = 'pickYourPlanScreen',
  MEDICARE_LANDING = 'medicareLandingPage',
  HS_PAYMENT_HISTORY = 'hsPaymentHistory',
  TERMS_OF_USE = 'termsOfUse',
  NO_ACCESS = 'noAccessPage',
  SESSION_TIMEOUT = 'sessionTimeOutPage',
  LOGGED_OUT = 'loggedOut',
   AUTO_PAY_PREMIUM_PAYMENT = 'autopayPremiumPaymentsPage',
   AUTOMATIC_PAYMENTS_SETUP = 'autoBillPayPage',
   HS_GLOBAL_ERROR = 'hsGlobalError',
}

export enum COMMON_COMPONENTS {
  HEADER = 'header',
  CANCEL = 'cancel',
  CANCEL_MODAL_CONTENT = 'cancelScheduledPaymentModal',
  CONVERSION_MODAL = 'conversionModal',
  ACTIVE_MEMBER_FOOTER = 'activeMemberFooter',
  FOOTER = 'footer',
  SESSION_TIMEOUT = 'sessionTimeout',
  NAVIGATION_BAR = 'navigationBar',
  LOADER_MESSAGE = 'preloaderMessage',
  OLD_CONVERSION_MODAL = 'oldConversionModal',
  AUTOPAY_ENROLMENT_MODAL = 'autopayEnrolmentModal',
  GUEST_GOVERNMENT_FOOTER = 'guestGovernmentFooter',
  ACTIVE_GOVERNMENT_FOOTER = 'activeGovernmentFooter',
  HOURS_OF_OPERATION = 'hoursOfOperation',
  AUTOPAY_SETUP_MODAL_CONTENT = 'autopaySetupModal',
  GUEST_AUTOPAY_SETUP_MODAL_CONTENT = 'guestAutopaySetupModal',
  BROKER_AUTOPAY_SETUP_MODAL_CONTENT = 'brokerAutopaySetupModal',
  ECONSENT_MODAL_CONTENT = 'econsentModal',
}

// while adding key please make sure key name matches with the actual response.
export const REQUIRED_HTML_TAGS: any = {
  [PAGE_NAME.MEMBER_VALIDATION]: {
    bannerMessage: true,
  },
  [PAGE_NAME.PAYMENT_TERMS]: {
    termsAndCondition: true,
  },
  [COMMON_COMPONENTS.FOOTER]: {
    footerDetails: true,
  },
  [COMMON_COMPONENTS.ACTIVE_MEMBER_FOOTER]: {
    footerDetails: true,
  },
  [COMMON_COMPONENTS.GUEST_GOVERNMENT_FOOTER]: {
    footerDetails: true,
  },
  [COMMON_COMPONENTS.ACTIVE_GOVERNMENT_FOOTER]: {
    footerDetails: true,
  },
  [COMMON_COMPONENTS.HEADER]: {
    exitText: true,
    languageAssistance: true,
  },
  [COMMON_COMPONENTS.ECONSENT_MODAL_CONTENT]: {
    description: true,
  },
  [PAGE_NAME.BROWSER_INCOMPATIBLE_ERROR]: {
    chromeLink: true,
    edgeLink: true,
    fireFoxLink: true,
    ielink: true,
    operaLink: true,
    safariLink: true,
  },
  [PAGE_NAME.TECHNICAL_DIFFICULTY]: {
    message: true,
    genericErrorMessage: true,
  },
  [PAGE_NAME.AUTO_PAYMENT_SUCCESS]: {
    autoBillPayActivationMessage: true,
    brokerAutopayAssistanceAlert: true,
  },
  [PAGE_NAME.AUTO_PAY_PREMIUM_PAYMENT]: {
    autopayPremiumPayments: true,
    autoBillPay: true,
  },
  [PAGE_NAME.HS_PAYMENT_HISTORY]: {
    tableHeader: true,
  },
  [PAGE_NAME.UNABLE_TO_PROCESS_PAYMENT]: {
    billingAccountVelocityReached: true,
    termedCABody: true,
    termedCAGovtBody: true,
  },
  [PAGE_NAME.BINDER_PAY_LATER_CONFIRMATION_PAYMENT_DETAILS]: {
    autopayFail: true,
    bodyApplicationTracker: true,
  },
  [PAGE_NAME.BINDER_PAY_LATER_SCHEDULE_CONFIRMATION_PAYMENT_DETAILS]: {
    autopayScheduleFail: true,
  },
  [COMMON_COMPONENTS.CONVERSION_MODAL]: {
    description: true,
  },
  [COMMON_COMPONENTS.OLD_CONVERSION_MODAL]: {
    description: true,
  },
  [PAGE_NAME.BINDER_MAKE_PAYMENT]: {
    paymentProcessedModalDescription: true,
  },
  [PAGE_NAME.AUTO_PAYMENT_SETTINGS]: {
    memberEmailMaximumLengthIL: true,
    memberEmailMinimumLengthIL: true,
    memberEmailMaximumLengthTX: true,
    memberEmailMinimumLengthTX: true,
    memberEmailMaximumLengthNM: true,
    memberEmailMinimumLengthNM: true,
    memberEmailMaximumLengthOK: true,
    memberEmailMinimumLengthOK: true,
    memberEmailMaximumLengthMT: true,
    memberEmailMinimumLengthMT: true,
    errorInvalidEmailFormatMobile: true,
    errorMaximumEmailLengthMobile: true,
    autopayAssistanceAlert: true,
    disclosureAutopayCheckbox: true,
    bodyAutoBillPayTerms: true,
  },
  [PAGE_NAME.MY_WALLET]: {
    myWalletToastMessageForLockdown: true,
    myWalletToastMessageForFreeze: true,
    myWalletToastMessageForNonAutoPay: true,
    mapdOrPdpUnableToProcess: true,
    memberEmailInvalidFormatErrorMessageIL: true,
    memberEmailLengthValidationErrorMessageIL: true,
    memberEmailInvalidFormatErrorMessageTX: true,
    memberEmailLengthValidationErrorMessageTX: true,
    memberEmailInvalidFormatErrorMessageNM: true,
    memberEmailLengthValidationErrorMessageNM: true,
    memberEmailInvalidFormatErrorMessageOK: true,
    memberEmailLengthValidationErrorMessageOK: true,
    memberEmailInvalidFormatErrorMessageMT: true,
    memberEmailLengthValidationErrorMessageMT: true,
    govEmailInvalidFormatErrorMessageIL: true,
    govEmailLengthValidationErrorMessageIL: true,
    govEmailInvalidFormatErrorMessageTX: true,
    govEmailLengthValidationErrorMessageTX: true,
    govEmailInvalidFormatErrorMessageNM: true,
    govEmailLengthValidationErrorMessageNM: true,
    govEmailInvalidFormatErrorMessageOK: true,
    govEmailLengthValidationErrorMessageOK: true,
    govEmailInvalidFormatErrorMessageMT: true,
    govEmailLengthValidationErrorMessageMT: true,
    errorInvalidEmailFormatMobile: true,
    errorMaximumEmailLengthMobile: true,
  },
  [PAGE_NAME.PAYMENT_DETAILS]: {
    mapdUnableToProcess: true,
    pdpUnableToProcess: true,
    govtSchedulePaymentMsg: true,
    autoPayUpdateMsg: true,
  },
  [PAGE_NAME.ALL_PAYMENT_DETAILS]: {
    autoPayUpdateMsg: true,
  },
  [PAGE_NAME.REVIEW_PAYMENT_DETAILS]: {
    caPaymentAccountBlocked: true,
    caPaymentAccountVelocityReached: true,
    caFundingAccountCardExpired: true,
    caInvalidAccountOrRoutingNumber: true,
    caUnsupportedCard: true,
    caCommercialCreditCard: true,
    caEmailMinimumLength: true,
    caEmailMaximumLength: true,
    govMemberEmailInvalidFormatErrorMessageIL: true,
    govMemberEmailInvalidFormatErrorMessageTX: true,
    govMemberEmailInvalidFormatErrorMessageNM: true,
    govMemberEmailInvalidFormatErrorMessageOK: true,
    govMemberEmailInvalidFormatErrorMessageMT: true,
    govMemberEmailLengthValidationErrorMessageIL: true,
    govMemberEmailLengthValidationErrorMessageTX: true,
    govMemberEmailLengthValidationErrorMessageNM: true,
    govMemberEmailLengthValidationErrorMessageOK: true,
    govMemberEmailLengthValidationErrorMessageMT: true,
    errorInvalidEmailFormatMobile: true,
    errorMaximumEmailLengthMobile: true,
    govIsAccountOrRoutingNumberInvalidLabel: true,
    disclosurePaymentCheckbox: true,
  },
  [PAGE_NAME.REVIEW_PAYMENT_DETAILS_ACTIVE_MEMBER]: {
    caPaymentAccountBlocked: true,
    caPaymentAccountVelocityReached: true,
    caFundingAccountCardExpired: true,
    caInvalidAccountOrRoutingNumber: true,
    caUnsupportedCard: true,
    caCommercialCreditCard: true,
    caEmailMinimumLength: true,
    caEmailMaximumLength: true,
    memberEmailInvalidFormatErrorMessageIL: true,
    memberEmailInvalidFormatErrorMessageTX: true,
    memberEmailInvalidFormatErrorMessageNM: true,
    memberEmailInvalidFormatErrorMessageOK: true,
    memberEmailInvalidFormatErrorMessageMT: true,
    memberEmailLengthValidationErrorMessageIL: true,
    memberEmailLengthValidationErrorMessageTX: true,
    memberEmailLengthValidationErrorMessageNM: true,
    memberEmailLengthValidationErrorMessageOK: true,
    memberEmailLengthValidationErrorMessageMT: true,
    govMemberEmailInvalidFormatErrorMessageIL: true,
    govMemberEmailInvalidFormatErrorMessageTX: true,
    govMemberEmailInvalidFormatErrorMessageNM: true,
    govMemberEmailInvalidFormatErrorMessageOK: true,
    govMemberEmailInvalidFormatErrorMessageMT: true,
    govMemberEmailLengthValidationErrorMessageIL: true,
    govMemberEmailLengthValidationErrorMessageTX: true,
    govMemberEmailLengthValidationErrorMessageNM: true,
    govMemberEmailLengthValidationErrorMessageOK: true,
    govMemberEmailLengthValidationErrorMessageMT: true,
    govIsAccountOrRoutingNumberInvalidLabel: true,
    errorInvalidEmailFormatMobile: true,
    errorMaximumEmailLengthMobile: true,
  },
  [PAGE_NAME.REVIEW_BINDER_PAYMENT_DETAILS]: {
    caPaymentAccountBlocked: true,
    caPaymentAccountVelocityReached: true,
    caFundingAccountCardExpired: true,
    caInvalidAccountOrRoutingNumber: true,
    caUnsupportedCard: true,
    caCommercialCreditCard: true,
    caEmailMinimumLength: true,
    caEmailMaximumLength: true,
    memberEmailInvalidFormatErrorMessageIL: true,
    memberEmailInvalidFormatErrorMessageTX: true,
    memberEmailInvalidFormatErrorMessageNM: true,
    memberEmailInvalidFormatErrorMessageOK: true,
    memberEmailInvalidFormatErrorMessageMT: true,
    memberEmailLengthValidationErrorMessageIL: true,
    memberEmailLengthValidationErrorMessageTX: true,
    memberEmailLengthValidationErrorMessageNM: true,
    memberEmailLengthValidationErrorMessageOK: true,
    memberEmailLengthValidationErrorMessageMT: true,
  },
  [PAGE_NAME.NO_ACCESS]: {
    noAccessContent: true,
  },
   [PAGE_NAME.MAPD_PAYMENTS]: {
     mapdPremiumPaymentsHeading: true,
     mapdPremiumPaymentsIntro: true,
     mapdPremiumPaymentsPayPremiumBillLabel: true,
     mapdPremiumPaymentsNextBillAmountDueDateLabel: true,
     mapdPremiumPaymentsPaymentHistoryLabel: true,
     mapdPremiumPaymentsFooterNote: true,
     mapdOneTimeOnlinePaymentLabel: true,
     mapdOneTimeOnlinePaymentUrl: true,
   },
   [PAGE_NAME.HS_GLOBAL_ERROR]: {
     noPoliciesHeading: true,
     noPoliciesDescription: true,
   },
};
